import React, { useState, useEffect, useRef, useContext } from 'react';
import { Menu, message, Button, Empty } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import apis from '@/apis/room/index';
import './index.less';
import Detail from '../components/tower-page-detail';
import AddPage from '../components/create-tower-page';
import TowerBanner from '../components/tower-banner';
import CreateTowerProject from '../components/create-tower-project';
import { getQuery } from '@/common/utils';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import ComponentLog from '@/components/component-log';

const TowerProject = () => {
  const [selectedKey, setSelectedKey] = useState(0);
  const [venueData, setVenueData] = useState({});
  const [visible, setVisible] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const detailRef = useRef();
  const value = useContext(ContextProviderMenus);
  const roomId = value.roomId;
  const power = value?.permission?.modules?.functions.tower_activity;
  const { tower_activity_create, tower_header_info, tower_page_list } = power ? power : {};

  const toRefresh = () => {
    setRefresh(!refresh);
  };

  const handleClick = (e) => {
    setSelectedKey(e.key);
    detailRef.current.refresh();
  };

  useEffect(() => {
    if (!roomId) return;
    apis
      .towerHeader({ roomId })
      .then(({ ret, msg, data }) => {
        if (ret === '0') {
          setVenueData(data.roomHeader);
          setSelectedKey(data.roomHeader?.pages[0].id);
        } else {
          message.error(msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, roomId]);

  const getData = () => {
    if (!venueData.pages) return;
    const result = venueData.pages.filter((item) => item.id === selectedKey);
    return result[0] ? { data: result[0], otherData: { ...venueData } } : false;
  };

  const isNoPower = power ? Object.values(power).every((item) => item === 0) : false;

  return !isNoPower && venueData ? (
    <div style={{ background: '#ffffff' }}>
      <div className="venue-activities__wrapper">
        {tower_header_info === 1 && (
          <TowerBanner cardItem={venueData} refresh={toRefresh} roomId={roomId} power={power} />
        )}
        {tower_activity_create === 1 && (
          <div className="venue-activities__create__wrapper">
            <ComponentLog clstag="resource_1627030927203|55">
              <Button
                type="primary"
                className="venue-activities__add-page"
                onClick={() => {
                  setVisible(true);
                }}
              >
                <PlusOutlined />
                新建页面
              </Button>
            </ComponentLog>
            <AddPage visible={visible} setVisible={setVisible} towerId={venueData?.id} refresh={toRefresh} />
          </div>
        )}
        {tower_page_list === 1 && (
          <>
            <div className="tower-menu__wrapper">
              <Menu onClick={handleClick} selectedKeys={[selectedKey]} mode="horizontal">
                {venueData &&
                  venueData.pages &&
                  venueData.pages.map((item) => <Menu.Item key={item.id}>{item.name}</Menu.Item>)}
              </Menu>
            </div>
            {getData() && <Detail {...getData()} ref={detailRef} towerId={venueData?.id} />}
          </>
        )}
      </div>
    </div>
  ) : (
    <div className="tower-project_empty-wrapper">
      <Empty description="暂无通天塔项目，请先新建通天塔项目！">
        {tower_activity_create === 1 && <CreateTowerProject type={1} roomId={roomId} refresh={toRefresh} />}
      </Empty>
    </div>
  );
};

export default TowerProject;
